module.exports = __webpack_public_path__ + "r-v3/img/gt-Volume_off.8ba6e3c4.svg";